import React, { Component } from 'react';

import HeaderCanvas from './HeaderCanvas';
import UserHeaderCanvas from './UserHeaderCanvas';

interface CustomProps {
  headerType?: 'logged-in' | 'pre-login';
  history?:any
}
class Header extends Component<CustomProps> {
  render() {
    return this.props.headerType !== 'logged-in' ? (
      <HeaderCanvas history={this.props.history} />
    ) : (
      <UserHeaderCanvas />
    );
  }
}

export default Header;
